<template>
  <div>
    <h4 class="text-h4">{{ $t("pages.documentRequest.title") }}</h4>
    <v-spacer class="mb-4"></v-spacer>
    <div>
      <v-row no-gutters>
        <v-col col="12" lg="8">
          <v-card elevation="1">
            <v-card-text>
              <p class="text-h4 text--primary text-center">
                {{
                  type === "Accept"
                    ? $t("pages.documentRequest.confirmAccept")
                    : $t("pages.documentRequest.confirmReject")
                }}
              </p>
              <p class="text-body-1 text-center">
                {{ $t("pages.documentRequest.instruction") }}
              </p>
              <v-row>
                <v-spacer />
                <v-col cols="4">
                  <v-btn
                    color="primary"
                    class="fill-width"
                    @click="submitResponse"
                  >
                    {{
                      type === "Accept"
                        ? $t("pages.documentRequest.accept")
                        : $t("pages.documentRequest.reject")
                    }}
                  </v-btn>
                </v-col>
                <v-spacer />
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { appLayout } from "@/util/layout";

export default {
  layout: appLayout({ title: "pages.documentRequest.pageTitle" }),
  props: {
    id: String,
    type: String,
    token: String,
  },
  methods: {
    submitResponse() {
      if (this.type === "Accept") {
        this.$inertia.post(
          this.route("document-requests.accept", {
            id: this.id,
            token: this.token,
          })
        );
      } else if (this.type === "Reject") {
        this.$inertia.post(
          this.route("document-requests.reject", {
            id: this.id,
            token: this.token,
          })
        );
      }
    },
  },
};
</script>
